import { InjectedConnector } from '@web3-react/injected-connector'
import { ensureResolvedInjectedProvider } from '../utils/injectedEthereum'

/**
 * web3-react InjectedConnector reads window.ethereum directly.
 * Before each call, resolve MetaMask (or any non-Brave EIP-6963 provider)
 * so Brave's proxied window.ethereum does not break ethers/web3-react.
 */
export class BraveSafeInjectedConnector extends InjectedConnector {
  activate(): ReturnType<InjectedConnector['activate']> {
    ensureResolvedInjectedProvider()
    return super.activate()
  }

  getProvider(): ReturnType<InjectedConnector['getProvider']> {
    ensureResolvedInjectedProvider()
    return super.getProvider()
  }

  getChainId(): ReturnType<InjectedConnector['getChainId']> {
    ensureResolvedInjectedProvider()
    return super.getChainId()
  }

  getAccount(): ReturnType<InjectedConnector['getAccount']> {
    ensureResolvedInjectedProvider()
    return super.getAccount()
  }

  deactivate(): void {
    ensureResolvedInjectedProvider()
    super.deactivate()
  }

  isAuthorized(): ReturnType<InjectedConnector['isAuthorized']> {
    ensureResolvedInjectedProvider()
    return super.isAuthorized()
  }
}